<template>
    <div class="container-fluid h-full">
        <Map
                    :center="{ lat: 36.8663, lng: 10.187 }" 
                    :zoom="8"
                    class="w-full h-72 md:h-96"
                    >
                    <Marker
                            v-for="(element, index) in elements"
                            :key="index"
                            :position="{ lat: parseFloat(element.lat), lng: parseFloat(element.lng) }"
                            :title="element.name"
                            :icon="{ url: icon }"
                            @click="openInfoWindow(index)"
                        >
                        <InfoWindow
                v-if="infoWindowOpen === index"
                @closeclick="infoWindowOpen = null"
              >
                <div class="text-black">
<img
  :src="elements[index]['cover']"
  :alt="elements[index]['name'] || 'Cover Image'"
  width="208"
  height="128"
  class="w-52 h-32 rounded-2xl"
/>
                  <div class="text-blue font-bold" v-if="currentLanguage==='fr'">
                    {{ elements[index]["name"] }}
                  </div>
                  <div class="text-blue font-bold" v-if="currentLanguage==='ar'">
                    {{ elements[index]["name_ar"] }}
                  </div>
                  <div class="text-blue font-bold" v-if="currentLanguage==='en'">
                    {{ elements[index]["name_en"] }}
                  </div>
                  <div class="text-blue font-bold" v-if="currentLanguage==='ru'">
                    {{ elements[index]["name_ru"] }}
                  </div>
                  <div class="text-blue font-bold" v-if="currentLanguage=== 'ja'">
                    {{ elements[index]["name_ja"] }}
                    </div>
                  <div class="text-blue font-bold" v-if="currentLanguage=== 'ko'">
                    {{ elements[index]["name_ko"] }}
                  </div>
                  <div class="text-blue font-bold" v-if="currentLanguage==='zh'">
                    {{ elements[index]["name_zh"] }}
                  </div>
                </div>
              </InfoWindow>
                    </Marker>
        </Map>
    </div>
</template>
<script>
import { Map, Marker,InfoWindow } from '@fawmi/vue-google-maps';
 export default{
    components: {
        Map,
        Marker,
        InfoWindow
    },
    props: {
    elements: {
      type: Array,
      required: true,
    },
    icon: String
  },
  data(){
    return{
        infoWindowOpen: null,
        currentLanguage: this.$i18n.locale
    }
  },
  methods:{
    openInfoWindow(index) {
      this.infoWindowOpen = index;
    },
  },
  watch: {
    "$i18n.locale"(newLocale) {
      this.currentLanguage = newLocale;
    },
  },
 }
</script>